/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for NotificationSettings model.
 * Handles team-based notification preferences for different content types and severities.
 * @export
 * @interface PatchedNotificationSettings
 */
export interface PatchedNotificationSettings {
    /**
     * 
     * @type {string}
     * @memberof PatchedNotificationSettings
     */
    readonly teamSlug?: string;
    /**
     * Enable notifications for findings
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyFindings?: boolean;
    /**
     * Enable notifications for domains
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyDomains?: boolean;
    /**
     * Enable notifications for subdomains
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifySubdomains?: boolean;
    /**
     * Enable notifications for IP addresses
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyIpAddresses?: boolean;
    /**
     * Enable notifications for ports
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyPorts?: boolean;
    /**
     * Enable notifications for public leaks
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyPublicLeaks?: boolean;
    /**
     * Enable notifications for stealer leaks
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyStealerLeaks?: boolean;
    /**
     * Enable notifications for data leaks
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyDataLeaks?: boolean;
    /**
     * Enable notifications for critical findings
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyCriticalFindings?: boolean;
    /**
     * Enable notifications for high severity findings
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyHighFindings?: boolean;
    /**
     * Enable notifications for medium severity findings
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyMediumFindings?: boolean;
    /**
     * Enable notifications for low severity findings
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyLowFindings?: boolean;
    /**
     * Enable notifications for informational findings
     * @type {boolean}
     * @memberof PatchedNotificationSettings
     */
    notifyInfoFindings?: boolean;
    /**
     * Email address to send notifications to
     * @type {string}
     * @memberof PatchedNotificationSettings
     */
    notificationEmail?: string | null;
    /**
     * Slack webhook URL to send notifications to
     * @type {string}
     * @memberof PatchedNotificationSettings
     */
    slackWebhookUrl?: string | null;
}

/**
 * Check if a given object implements the PatchedNotificationSettings interface.
 */
export function instanceOfPatchedNotificationSettings(value: object): value is PatchedNotificationSettings {
    return true;
}

export function PatchedNotificationSettingsFromJSON(json: any): PatchedNotificationSettings {
    return PatchedNotificationSettingsFromJSONTyped(json, false);
}

export function PatchedNotificationSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedNotificationSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'teamSlug': json['team_slug'] == null ? undefined : json['team_slug'],
        'notifyFindings': json['notify_findings'] == null ? undefined : json['notify_findings'],
        'notifyDomains': json['notify_domains'] == null ? undefined : json['notify_domains'],
        'notifySubdomains': json['notify_subdomains'] == null ? undefined : json['notify_subdomains'],
        'notifyIpAddresses': json['notify_ip_addresses'] == null ? undefined : json['notify_ip_addresses'],
        'notifyPorts': json['notify_ports'] == null ? undefined : json['notify_ports'],
        'notifyPublicLeaks': json['notify_public_leaks'] == null ? undefined : json['notify_public_leaks'],
        'notifyStealerLeaks': json['notify_stealer_leaks'] == null ? undefined : json['notify_stealer_leaks'],
        'notifyDataLeaks': json['notify_data_leaks'] == null ? undefined : json['notify_data_leaks'],
        'notifyCriticalFindings': json['notify_critical_findings'] == null ? undefined : json['notify_critical_findings'],
        'notifyHighFindings': json['notify_high_findings'] == null ? undefined : json['notify_high_findings'],
        'notifyMediumFindings': json['notify_medium_findings'] == null ? undefined : json['notify_medium_findings'],
        'notifyLowFindings': json['notify_low_findings'] == null ? undefined : json['notify_low_findings'],
        'notifyInfoFindings': json['notify_info_findings'] == null ? undefined : json['notify_info_findings'],
        'notificationEmail': json['notification_email'] == null ? undefined : json['notification_email'],
        'slackWebhookUrl': json['slack_webhook_url'] == null ? undefined : json['slack_webhook_url'],
    };
}

  export function PatchedNotificationSettingsToJSON(json: any): PatchedNotificationSettings {
      return PatchedNotificationSettingsToJSONTyped(json, false);
  }

  export function PatchedNotificationSettingsToJSONTyped(value?: Omit<PatchedNotificationSettings, 'team_slug'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notify_findings': value['notifyFindings'],
        'notify_domains': value['notifyDomains'],
        'notify_subdomains': value['notifySubdomains'],
        'notify_ip_addresses': value['notifyIpAddresses'],
        'notify_ports': value['notifyPorts'],
        'notify_public_leaks': value['notifyPublicLeaks'],
        'notify_stealer_leaks': value['notifyStealerLeaks'],
        'notify_data_leaks': value['notifyDataLeaks'],
        'notify_critical_findings': value['notifyCriticalFindings'],
        'notify_high_findings': value['notifyHighFindings'],
        'notify_medium_findings': value['notifyMediumFindings'],
        'notify_low_findings': value['notifyLowFindings'],
        'notify_info_findings': value['notifyInfoFindings'],
        'notification_email': value['notificationEmail'],
        'slack_webhook_url': value['slackWebhookUrl'],
    };
}

